

export type CustomFieldValue = {label: string, value: string|boolean|number, table: boolean};

export type CustomField = {
    id?: string;
    parent_id?: string;
    name: string;
    value: CustomFieldValue[];
};

export const customField = (): CustomField => {
    return {
        name: "Custom Field",
        value: []
    }
}

